import {SellerError} from './SellerError.js'

export class GetRecommendedPriceGenericSellerError extends SellerError {}
